import { client } from '../client/client.gen'
import { env } from '../../config/env'

export interface ApiConfig {
  baseUrl: string
  timeout?: number
  headers?: Record<string, string>
}

// Default configuration using environment variables
const defaultConfig: ApiConfig = {
  baseUrl: env.API_BASE_URL,
  timeout: env.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
}

// Initialize the API client
export function initializeApiClient(config: Partial<ApiConfig> = {}) {
  const finalConfig = { ...defaultConfig, ...config }

  client.setConfig({
    baseUrl: finalConfig.baseUrl,
    headers: finalConfig.headers,
    throwOnError: true,
  })

  return client
}

// Get current configuration
export function getApiConfig(): ApiConfig {
  return { ...defaultConfig }
}

// Update configuration
export function updateApiConfig(newConfig: Partial<ApiConfig>) {
  Object.assign(defaultConfig, newConfig)
  initializeApiClient(defaultConfig)
}

// Export the configured client
export { client as apiClient }
